/* eslint-disable import/no-cycle */
import React from 'react';
import Heading from './Heading';
import DocBlock from './JsDocBlock';
import JsDocTitleSignature from './JsDocTitleSignature';
export default function JsDocReturnBlock(_ref) {
  var _definition$returns, _definition$type, _def, _def$returns;

  var definition = _ref.definition,
      level = _ref.level;
  var def = ((_definition$returns = definition.returns) === null || _definition$returns === void 0 ? void 0 : _definition$returns.length) ? definition : (_definition$type = definition.type) === null || _definition$type === void 0 ? void 0 : _definition$type.typeDef;
  if (!((_def = def) === null || _def === void 0 ? void 0 : (_def$returns = _def.returns) === null || _def$returns === void 0 ? void 0 : _def$returns.length)) return null;
  def = def.returns[0];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    level: level
  }, "Return Value ", /*#__PURE__*/React.createElement(JsDocTitleSignature, {
    definition: def
  })), /*#__PURE__*/React.createElement(DocBlock, {
    definition: def,
    depth: level
  }));
}
export var fragment = "1304490256";